import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import ThreadMessages from "@/components/ThreadMessages";
import { ArrowLeft, MessageSquare } from "lucide-react";
import { useAuth, isStudent } from "@/lib/auth";

export default function ThreadDetail() {
  const { id } = useParams();
  const { user } = useAuth();
  const student = isStudent(user);

  const { data: thread, refetch } = useQuery({
    queryKey: ["thread", id],
    queryFn: async () => (await api.get(`/threads/${id}`)).data,
    refetchInterval: 15_000,
  });

  const backPath = student ? "/portale/messaggi" : "/messaggi";

  if (!thread) return <div className="p-10 text-stone-500 text-sm">Caricamento…</div>;

  return (
    <div className="p-4 sm:p-6 md:p-10 max-w-[1000px] mx-auto">
      <Link to={backPath} className="inline-flex items-center gap-1.5 text-xs text-stone-500 hover:text-[#1C352D] mb-4">
        <ArrowLeft size={13}/> Torna ai messaggi
      </Link>

      <Card className="p-6 border border-stone-200 rounded-xl shadow-none">
        <div className="flex items-center gap-2 mb-1">
          {thread.kind === "broadcast" && <Badge className="bg-[#E2725B] text-white text-[9px] rounded-full">BROADCAST</Badge>}
          {thread.kind === "direct" && <Badge className="bg-stone-100 text-stone-700 text-[9px] rounded-full">1-A-1</Badge>}
        </div>
        <div className="flex items-center gap-2">
          <MessageSquare size={16} className="text-stone-500"/>
          <h1 className="text-lg font-semibold text-[#1C352D]">{thread.subject || "(senza oggetto)"}</h1>
        </div>
        {!student && thread.student_name && (
          <div className="text-[11px] text-stone-500 mt-1">Con: <b>{thread.student_name}</b> · {thread.student_matricola}</div>
        )}
        <div className="mt-4">
          <ThreadMessages
            endpoint="threads"
            resourceId={id}
            messages={thread.messages}
            refetch={refetch}
          />
        </div>
      </Card>
    </div>
  );
}
